import type { RequestExtra } from 'Models/uiConfig/requestTypes';

export default async function convertibleFromObject(obj: RequestExtra): Promise<Record<string, string>> {
  const entries = await Promise.all(
    Object.entries(obj).map(async ([key, value]) => [key.toLowerCase(), await value] as const),
  );

  return Object.fromEntries(
    entries
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, encodeURIComponent(String(value))]),
  );
}
